<template>
  <div class="de-param-slider">
    <label>
      {{ label }}
      <EditableValue
        :value="value"
        :formatter="formatter"
        :min="min"
        :max="max"
        :error-message="errorMessage"
        @change="$emit('input', $event)"
      />
    </label>
    <el-slider
      :value="value"
      :min="min"
      :max="max"
      :step="step"
      :format-tooltip="tooltipFormatter"
      class="compact-slider"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import EditableValue from './InlineEditableNumber.vue'

export default {
  name: 'DeParamSlider',
  components: { EditableValue },
  props: {
    label: { type: String, required: true },
    value: { type: Number, required: true },
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    step: { type: Number, default: 0.01 },
    formatter: { type: Function, default: v => Number(v).toFixed(2) },
    tooltipFormatter: { type: Function, default: v => Number(v).toFixed(2) },
    errorMessage: { type: String, default: 'Value must be within range' }
  }
}
</script>

<style scoped>
.de-param-slider {
  margin-bottom: 12px;
}

.de-param-slider label {
  font-size: 14px;
  color: #374151;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.de-param-slider .compact-slider {
  padding: 0 2px;
}

/* Track - rounded with subtle styling */
.de-param-slider .compact-slider >>> .el-slider__runway {
  height: 5px;
  margin: 10px 0;
  background-color: #e2e8f0;
  border-radius: 4px;
}

.de-param-slider .compact-slider >>> .el-slider__bar {
  height: 5px;
  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 4px;
}

.de-param-slider .compact-slider >>> .el-slider__button-wrapper {
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Modern circular handle with gradient and shadow */
.de-param-slider .compact-slider >>> .el-slider__button {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 
    0 2px 4px rgba(37, 99, 235, 0.3),
    0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.15s ease;
}

.de-param-slider .compact-slider >>> .el-slider__button:hover {
  transform: scale(1.15);
  box-shadow: 
    0 3px 8px rgba(37, 99, 235, 0.4),
    0 2px 4px rgba(0, 0, 0, 0.15);
}

.de-param-slider .compact-slider >>> .el-slider__button:active {
  transform: scale(1.05);
}
</style>
